import React from 'react';

import {imageUrl} from '../../../../assets/scripts/utils/shopify-images';

const CartPromo = () => {
  const promoImage = window.theme.cartPromo ? window.theme.cartPromo.image : '';
  let promoImageURL = '';
  if(promoImage) {
    promoImageURL = promoImage.includes('https') || promoImage.includes('http') ? promoImage : `https:${promoImage}`;
  }
  const promoLink = window.theme.cartPromo ? window.theme.cartPromo.link : '';
  const promoIntroHeading = window.theme.cartPromo ? window.theme.cartPromo.introHeading : '';
  const promoHeading = window.theme.cartPromo ? window.theme.cartPromo.heading : '';
  const promoText = window.theme.cartPromo ? window.theme.cartPromo.text : '';

  return (
    <>
      <div className={`side-cart__promo${promoImageURL ? ' side-cart__promo--has-image' : ''}`}>
        {promoIntroHeading && (
          <h3 class="side-cart__promo-into-title h7">{promoIntroHeading}</h3>
        )}
        <div className="side-cart__promo-box">
          {promoImageURL && (
            <div className="side-cart__promo-image">
              <a href={promoLink}>
                <div className="side-cart__promo-image-wrapper component-image__wrapper aspect-ratio">
                  <img
                    src={imageUrl(promoImageURL, 640, 200, 'center')}
                    srcset={`${imageUrl(promoImageURL, 640, 200, 'center')} 640w, ${imageUrl(promoImageURL, 960, 300, 'center')} 960w, ${imageUrl(promoImageURL, 1440, 450, 'center')} 1440w`}
                    sizes="(min-width: 48rem) 28.75rem, 100vw"
                    width={1440}
                    height={450}
                    alt={promoHeading}
                    loading="lazy"
                  />
                </div>
              </a>
            </div>
          )}
          <div className="side-cart__promo-content">
            {promoHeading && (
              <h4 class="side-cart__promo-title h7">{promoHeading}</h4>
            )}
            {promoText && (
              <div
                className="side-cart__promo-text rte"
                dangerouslySetInnerHTML={{__html: promoText}}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CartPromo;
